import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import Modal from '../../Components/ComponentModal';
import T from '../../Locale';
const modalKey = 'value-image';
const ComponentModalImage = ({ currentModalKey = '', valueId }) => (_jsx(Modal, Object.assign({ modalKey: modalKey, title: T.translate('values.imageHeadline') }, { children: modalKey === currentModalKey && _jsx("img", { alt: "", src: `/values/${valueId}/image` }) })));
const mapStateToProps = (state) => {
    var _a, _b;
    return ({
        currentModalKey: (_a = state === null || state === void 0 ? void 0 : state.application) === null || _a === void 0 ? void 0 : _a.modal,
        valueId: (_b = state === null || state === void 0 ? void 0 : state.application) === null || _b === void 0 ? void 0 : _b.modalId
    });
};
export default connect(mapStateToProps)(ComponentModalImage);
